module.exports = __webpack_public_path__ + "media/images/icons/flags/GL-9bee6a3bb3b60c2165aeaeb12f111844.svg";